import { computed, inject, provide, reactive, ref, watchEffect } from 'vue';

import FormattingService from '@/services/formatting.service';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faRectangleXmark } from '@fortawesome/free-solid-svg-icons';
import { Api } from '@/services/api.service'

library.add(faRectangleXmark);

export default {
  name: 'Modal',
  props: {
    item: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      required: false,
      default: null,
    },
  },
  components: {
    FontAwesomeIcon
  },  
  setup(props) {
    const config = inject('config');
    
    const headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');

    const state = reactive({
      item: computed(() => props.item),
      image: computed(() => {
        if(state.item.type === 'event_session') {
          return state.item.event.image
        }
        return state.item.cover ? 
        (state.item.cover['540w'] ? state.item.cover['540w']: state.item.cover.full) : 
        ( state.item.images['540w'] ? state.item.images['540w'] : state.item.images.full)
      }),
      itemLink: computed(() => {
        if(state.item.type === 'event_session') {
          return FormattingService.formatUrl(state.item.event)
        }
        return state.item.type === 'magazine' ? state.item.viewer : FormattingService.formatUrl(state.item);
      }),
      link: computed(() => state.item.event.url),
      voucherCode: null,
    });





    watchEffect( async () => {
      if(!props.show) {
        state.voucherCode = null;
      }
      if(state.item.type === 'course' && state.item.trailer) {
         if(props.show) {
          setTimeout(() => {
            jwplayer('jwplayer').setup({
              'playlist': `https://cdn.jwplayer.com/v2/media/${state.item.trailer}`,
              'width': '100%',
              'height': '100%',
              'aspectratio': '16:9',
              'controls': true,
              'stretching': 'uniform',
              // 'autostart': false,
              'autostart': 'viewable',
              'mute': true,
              'displaytitle': false,
            });
          }, 0);                     
        }
      }
      if(state.item.type === 'toolkit' && state.item.toolkit_type === 'voucher' && props.user) {
        const response = await Api.get(`${config.api.uri}/${config.api.version}/toolkits/${state.item.id}/voucher_code?user=${props.user.id}&token=${props.user.token}`, headers);
        if(response.status !== 'error') {
          state.voucherCode = response.data.data.voucher_code;
        }
      }
    });

    return {
      state,
      FormattingService,
    }
  },
  methods: {
    toggleModal() {
      this.$emit('toggleModal', null);
    }
  }
}